import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

import { CSSTransition, TransitionGroup } from 'react-transition-group';
import Button from '#/components/Button';

import styles from './styles.module.css';

import { useTranslation } from "react-i18next";

function Modal({ title = '', children, isOpen, onClose, hideBtnClose = false, noPadding = false, noMargin = false }) {
  
  const overlay = useRef(null);
  const { t } = useTranslation();


  return (
    <TransitionGroup>
      <React.Fragment>
        {isOpen &&
          ReactDOM.createPortal(
            <div
              ref={overlay}
              className={styles.overlay}
            >
              <CSSTransition
                in={isOpen}
                timeout={500}
                classNames={{
                  enter: styles['move-enter'],
                  enterActive: styles['move-enter-active'],
                  exit: styles['move-exit'],
                  exitActive: styles['move-exit-active'],
                }}
              >
                <div className={[styles.modalWrapper, noPadding ? styles.noPadding : '', noMargin ? styles.noMargin : '', !isOpen ? styles.hide : ''].join(' ')}>
                  <div className={[styles.close, !isOpen ? styles.hide : ''].join(' ')} onClick={onClose}>
                    <span>&times;</span>
                  </div>
                  {title === null || title === undefined ? '' : <strong className={styles.title}>{title}</strong>}
                  {noPadding || noMargin ? <>{children}</> : <p className={styles.paragraph}>{children}</p>}
                  {hideBtnClose ? '' : <div className={styles.buttons}>
                    <Button autoFocus action={onClose}>
                      {t('CLOSE')}
                    </Button>
                  </div>}
                </div>
              </CSSTransition>
            </div>,
            document.body
          )}
      </React.Fragment>
    </TransitionGroup>
  );
}

Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string,
  children: PropTypes.node,
  onClose: PropTypes.func,
};

Modal.defaultProps = {
  onClose: () => null,
};

export default Modal;
